import baseURL from "../common/axios";
import { value } from "dom7";
class PackSizeservice {
  //Create API -> To Create Master
  createdata(form) {
    return baseURL.httpMSInventoryUrl.post("PackSizeMAS/Create", form);
  }
  //Get List API -> To Show Table Values
  getlistdata() {
    return baseURL.httpMSInventoryUrl.get("PackSizeMAS/List");
  }
  //Update API -> To Update Values in Form
  updatedata(form) {
    return baseURL.httpMSInventoryUrl.post("PackSizeMAS/Update", form);
  }
  //Get API -> To Get Values from Table
  getdata(form) {
    return baseURL.httpMSInventoryUrl.get("PackSizeMAS/Get?id=" + form);
  }
  //Delete -> To Delete Values from Table
  deletedata(form) {
    return baseURL.httpMSInventoryUrl.delete("PackSizeMAS/Delete?id=" + form);
  }
  //Active
  active(form, Status) {
    return baseURL.httpMSInventoryUrl.put(
      "PackSizeMAS/Active?id=" + form + "&Status=" + Status
    );
  }
}
export default new PackSizeservice();
